import styled from "styled-components";

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  margin-top: 15px;
  padding-bottom: 2.5rem;
  box-sizing: border-box;
  scroll-padding-bottom: 2.5rem;
  font-family: 'Inter', sans-serif;

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #c0c0c0;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: #ffffff;
    border-radius: 10px;
    border: 2px solid #c0c0c0;
  }

`